(() => {
  const instances = new WeakMap();

  function init(root) {
    if (instances.has(root)) return;
    const rows = [...root.querySelectorAll('.nvTrust__benefit')];
    if (!rows.length || !('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px 40px 0px' });
    rows.forEach(row => observer.observe(row));
    instances.set(root, observer);
    requestAnimationFrame(() => root.classList.add('is-ready'));
  }

  function scan(scope = document) { scope.querySelectorAll('.nvTrust').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  else scan();
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.nvTrust').forEach(root => { instances.get(root)?.disconnect(); instances.delete(root); });
  });
})();
